import { darken } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'MuiVideoOverlay' })(
  ({ brandColors, breakpoints, typography }) => ({
    container: {
      background: 'rgba(11, 14, 29, 0.9)',
      position: 'fixed',
      display: 'flex',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
    },
    videoIframe: {
      margin: 'auto',
      width: '100vw',
      height: 'calc(100vw * 9 / 16)',
    },
    closeButton: {
      position: 'absolute',
      top: typography.pxToRem(24),
      right: typography.pxToRem(24),
      height: typography.pxToRem(60),
      width: typography.pxToRem(60),
      borderRadius: typography.pxToRem(30),
      padding: typography.pxToRem(13),
      background: brandColors.white,
      color: brandColors.black,
      cursor: 'pointer',
      border: 'none',
      '&:hover': {
        background: darken('#fff', 0.07),
      },
      '&:active': {
        background: darken('#fff', 0.13),
      },
    },
    [breakpoints.up('sm')]: {
      videoIframe: {
        margin: 'auto',
        width: 'calc(100vw * 0.65)',
        height: 'calc(100vw * 0.65 * 9 / 16)',
      },
    },
    [breakpoints.up('md')]: {
      videoIframe: {
        margin: 'auto',
        width: 'calc(100vw * 0.72)',
        height: 'calc(100vw * 0.72 * 9 / 16)',
        maxWidth: typography.pxToRem(960),
        maxHeight: `calc(${typography.pxToRem(960)} * 9 / 16)`,
      },
      closeButton: {
        top: typography.pxToRem(40),
        right: typography.pxToRem(44),
      },
    },
  })
);

export default useStyles;
